import { Modal } from 'antd'
import clsx from 'clsx'
import React, { FC } from 'react'

type TProps = {
  visible: boolean
  width?: number
  style?: React.CSSProperties
  onCancel?: () => void
  classModal?: string
  maskClosable?: boolean
}

const Index: FC<TProps & { children: React.ReactNode }> = ({
  children,
  classModal,
  maskClosable,
  ...props
}) => {
  return (
    <Modal
      destroyOnClose={true}
      closable={true}
      maskClosable={maskClosable}
      footer={null}
      {...props}
      maskStyle={{ backgroundColor: 'rgba(252, 252, 252, 50%)' }}
      className={clsx(classModal, '2xl:top-[60px] top-[40px]')}
    >
      {children}
    </Modal>
  )
}

Index.defaultProps = {
  width: 768,
}

export default Index
